import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

class LampBaseSelectorComponent extends HTMLElement {
  connectedCallback() {
    this.options = Array.from(this.querySelectorAll('[data-lamp-base-option]'));
    this.selectedVariantId = '';
    this.options.forEach((option) => option.addEventListener('click', () => this.select(option)));

    this.querySelectorAll('[data-lamp-base-nav]').forEach((navButton) => {
      navButton.addEventListener('click', (event) => this.navigate(event));
    });

    this.querySelectorAll('dialog').forEach((dialog) => {
      dialog.addEventListener('close', () => {
        const panels = dialog.querySelector('[data-lamp-base-panels]');
        panels?.scrollTo({ left: 0, behavior: 'instant' });
      });
    });

    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate);
  }

  /** @param {MouseEvent} event */
  navigate(event) {
    const button = /** @type {HTMLElement} */ (event.currentTarget);
    const panels = button.closest('dialog')?.querySelector('[data-lamp-base-panels]');
    if (!(panels instanceof HTMLElement)) return;

    const direction = button.dataset.lampBaseNav === 'prev' ? -1 : 1;
    panels.scrollBy({ left: panels.clientWidth * direction, behavior: 'smooth' });
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate);
  }

  /** @param {HTMLElement} option */
  select(option) {
    this.options.forEach((other) => other.classList.remove('is-selected'));
    option.classList.add('is-selected');
    this.selectedVariantId = option.dataset.variantId || '';
  }

  /** @param {import('@shopify/events').CartLinesUpdateEvent} event */
  handleCartUpdate(event) {
    if (event.context !== 'product' || event.action !== 'add' || !this.selectedVariantId) return;

    const variantId = this.selectedVariantId;
    const deferred = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'lamp-base-addon',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((element) => /** @type {HTMLElement} */ (element).dataset.sectionId)
      .filter(Boolean);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds.join(','),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) throw new Error(data.message || 'Failed to add base');

        return fetch('/cart.js')
          .then((response) => response.json())
          .then((rawCart) => {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(rawCart),
              detail: {
                items: rawCart.items,
                sections: data.sections,
                source: 'lamp-base-selector',
                itemCount: 1,
              },
            });
          });
      })
      .catch((error) => {
        deferred.reject(error);
      });
  }
}

customElements.define('lamp-base-selector', LampBaseSelectorComponent);
